import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ipage',
	templateUrl:'./IPagePluginCompPage.html',
	styles: [],
	styleUrls:['./IPagePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class IPagePluginCompPage
{
	mdContent_985 = `\`\`\`java
import com.jwebmp.client.IPage;
\`\`\``;
	mdContent_986 = `\`\`\`java
@PageConfiguration(url = "/dashboard")
public class DashboardPage extends Page&lt;DashboardPage&gt; {
    public DashboardPage() {
        getBody().add(new H1&lt;&gt;().setText("Dashboard"));
    }
}
\`\`\``;
}
